/**
 * @Description 飞书相关
 */
import { getCookie, removeCookie } from '@lhb/cache';
import { urlParams } from '@lhb/func';
import { authenticationByLark } from '../api/common';

export enum ThirdPartyPlatformType {
  DD = 1, // 钉钉
  QW, // 企微
  WECHART, // 微信
  LARK, // 飞书
}
// 飞书环境下的消息推送的两个路由地址(pc的路由，需要做一层映射)
export const targetMsgPathOfLark = [
  '/expandstore/expansiontask',
  '/expandstore/approver'
];

/**
 * 场景：处理飞书环境内工作台/审批消息访问Location时401的场景
 */
export const handleInterceptInLark = () => {
  const { appId, appID } = urlParams(window.location.search);
  const { href, origin } = window.location;
  const curUrl = href; // 当前页地址
  // 审批页场景
  if (appId || appID) { // 飞书链接
    removeCookie('flow_token');
    removeCookie('flow_share_token');
    removeCookie('tenantId');
    removeCookie('employeeId');
    // 注意默认登录页/feishu/exemption页面使用的是大写的appID，而消息链接里服务端拼的是小写的appId.，另外需要对curUrl进行编码，在对应的免登页解码
    window.location.replace(`${origin}/feishu/exemption?appID=${appId || appID}&originUrl=${encodeURIComponent(curUrl)}`);
    return;
  }
};

/**
 * 飞书网页JSAPI进行鉴权
 * @param {Number} tenantId 租户id（即：登录成功后才可以调用）
 * @param {Array} jsApiList api列表 https://open.feishu.cn/document/client-docs/h5/
 */
export const apiAuthForLark = async (jsApiList: any[]) => {
  const params: any = {
    url: window.location.href,
    appId: getCookie('APP_ID')
  };
  const res = await authenticationByLark(params);
  const { appId, timestamp, noncestr, signature } = res;
  return new Promise((resolve, reject) => {
    let configSuccessRes = {};
    window.h5sdk.config({
      appId,
      timestamp,
      nonceStr: noncestr,
      signature,
      jsApiList,
      // 鉴权成功回调
      onSuccess: (successRes: any) => {
        configSuccessRes = successRes;
      },
      // 鉴权失败回调
      onFail: (err) => {
        reject(`${JSON.stringify(err)}`);
      },
    });
    window.h5sdk.ready(() => {
      resolve(configSuccessRes);
    });
  });
};
